import React, { useEffect, useLayoutEffect, useRef, useState } from "react"
import { createPortal } from "react-dom"
import { MdMoreVert } from "react-icons/md"
import styles from './tr.module.css'

const Tr = ({ row = {}, indexRow = false, onClick }) => {
    const [anchor, setAnchor] = useState(null)
    const [position, setPosition] = useState({ visibility: "hidden" })
    const triggerRef = useRef(null)
    const menuRef = useRef(null)
    const close = () => setAnchor(null)

    useLayoutEffect(() => {
        if (!anchor || !menuRef.current) return
        const margin = 8
        const gap = 4
        const rect = triggerRef.current.getBoundingClientRect()
        const menu = menuRef.current.getBoundingClientRect()
        const width = Math.min(menu.width, window.innerWidth - margin * 2)
        const height = Math.min(menu.height, window.innerHeight - margin * 2)
        const desiredTop = anchor.type === "pointer" ? anchor.y : (
            rect.bottom + gap + height <= window.innerHeight - margin ? rect.bottom + gap : rect.top - gap - height
        )
        const desiredLeft = anchor.type === "pointer" ? anchor.x : rect.right - width
        setPosition({
            top: Math.max(margin, Math.min(desiredTop, window.innerHeight - height - margin)),
            left: Math.max(margin, Math.min(desiredLeft, window.innerWidth - width - margin)),
            visibility: "visible",
        })
        menuRef.current.querySelector("button")?.focus()
    }, [anchor])

    useEffect(() => {
        if (!anchor) return
        const handleKey = event => {
            if (event.key === "Escape") { close(); triggerRef.current?.focus() }
        }
        const handleScroll = event => {
            if (!menuRef.current?.contains(event.target)) close()
        }
        window.addEventListener("resize", close)
        window.addEventListener("scroll", handleScroll, true)
        window.addEventListener("keydown", handleKey)
        return () => {
            window.removeEventListener("resize", close)
            window.removeEventListener("scroll", handleScroll, true)
            window.removeEventListener("keydown", handleKey)
        }
    }, [anchor])

    const open = next => { setPosition({ visibility: "hidden" }); setAnchor(next) }
    const handleContextMenu = event => {
        if (!row.actions?.length) return
        event.preventDefault()
        event.stopPropagation()
        open({ type: "pointer", x: event.clientX, y: event.clientY })
    }

    return <tr onClick={onClick} onContextMenu={handleContextMenu}>
        {indexRow > 0 && <td>{indexRow}</td>}
        {row.value?.map((data, index) => <td key={index}>{data}</td>)}
        {row.actions && <td align="end" className={styles.actions}>
            <button type="button" ref={triggerRef} className={styles.trigger} aria-label="Opções do registro" aria-expanded={Boolean(anchor)} onClick={event => {
                event.stopPropagation()
                if (anchor) close()
                else open({ type: "button" })
            }}><MdMoreVert /></button>
            {anchor && createPortal(<div className={styles.background} onClick={event => { event.stopPropagation(); close() }} onContextMenu={event => { event.preventDefault(); event.stopPropagation(); close() }}>
                <ul ref={menuRef} className={styles.menu} style={position} aria-label="Opções do registro" onClick={event => event.stopPropagation()}>
                    {row.actions.map((action, index) => <li key={index}><button type="button" onClick={event => {
                        event.stopPropagation()
                        close()
                        action.onClick(row.id)
                    }}>{action.label}</button></li>)}
                </ul>
            </div>, document.body)}
        </td>}
    </tr>
}

export default Tr
